<template>
  <div class="page">
    <div class="m-b-24 bg-content padding15">
      <el-form size="small" label-width="80px">
        <el-row :gutter="24">
          <el-col :span="10">
            <el-form-item label="公司">
              <el-select v-model="company.companySelected" filterable placeholder="请选择" style="width: 100%;" @change="companyChange">
                <el-option v-for="item in company.companyOption" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="策略组">
              <el-select v-model="group.groupSelected" placeholder="请选择" style="width: 80%;" @change="groupChange" filterable>
                <el-option
                  v-for="item in group.groupOption"
                  :key="item.id"
                  :label="item.groupName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <div class="text right">
              <el-dropdown trigger="click">
                <el-button type="primary" size="small">
                  策略模板设置<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <!-- <el-dropdown-item @click.native="strategyConfig" v-if="this.$hasPerm('B031')">策略配置</el-dropdown-item> -->
                  <el-dropdown-item @click.native="addStrategy(null)" v-if="this.$hasPerm('B032')">添加策略组</el-dropdown-item>
                  <el-dropdown-item @click.native="updateStrategyVisible = true" v-if="this.$hasPerm('B025')">更新策略和模板</el-dropdown-item>
                  <el-dropdown-item @click.native="addTemplate">创建模板</el-dropdown-item>
                  <el-dropdown-item @click.native="updateTemplateVisible = true" v-if="this.$hasPerm('B027')">批量更新模板</el-dropdown-item>
                  <el-dropdown-item @click.native="groupConfig" v-if="this.$hasPerm('B031')">策略组配置</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="bg-content padding15">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="策略总览" name="策略总览">
          <strategy-overview ref="strategyOverview" v-bind:changeTabe="activeTab" :companySelected="company.companySelected" @refreshList="onRefresList" @updateGroup="updateGroup" @strategyRouteConfig="strategyRouteConfig"></strategy-overview>
        </el-tab-pane>
        <el-tab-pane label="策略明细" name="策略明细" v-if="this.$hasPerm('B008&7')">
          <send-rule ref="sendRule" v-bind:changeTabe="activeTab" :companySelected="company.companySelected" :groupSelected="group.groupSelected" :labelOption="labelOption" :templateMsgOption="templateMsgOption" :templateVoiceOption="templateVoiceOption" :templateIVoiceOption="templateIVoiceOption" :templateSVoiceOption="templateSVoiceOption"></send-rule>
        </el-tab-pane>
        <el-tab-pane label="语音模板列表" name="语音模板列表" v-if="this.$hasPerm('B008&1')">
          <voice-template-list ref="voiceTemplateList" v-bind:changeTabe="activeTab" :companySelected="company.companySelected" :groupSelected="group.groupSelected" :initTemplateFiled="initTemplateFiled" :addOrEditTemplate="addOrEditTemplate" :deleteTemplate="deleteTemplate" :openAndCloseTemplate="openAndCloseTemplate"></voice-template-list>
        </el-tab-pane>
        <el-tab-pane label="智能语音模版" name="智能语音模版" v-if="this.$hasPerm('B008&1')">
          <ivoice-template-list ref="ivoiceSceneTemplateList" v-bind:changeTabe="activeTab" :companySelected="company.companySelected" :groupSelected="group.groupSelected" :companyAmount="this.company.amount" :initTemplateFiled="initTemplateFiled" :addOrEditTemplate="addOrEditTemplate" :deleteTemplate="deleteTemplate" :openAndCloseTemplate="openAndCloseTemplate"></ivoice-template-list>
        </el-tab-pane>
        <el-tab-pane label="短信模板列表" name="短信模板列表" v-if="this.$hasPerm('B008&2')">
          <msg-template-list ref="msgTemplateList" v-bind:changeTabe="activeTab" :companySelected="company.companySelected" :groupSelected="group.groupSelected" :initTemplateFiled="initTemplateFiled" :addOrEditTemplate="addOrEditTemplate" :deleteTemplate="deleteTemplate" :openAndCloseTemplate="openAndCloseTemplate"></msg-template-list>
        </el-tab-pane>
        <el-tab-pane label="对话语音场景" name="对话语音场景" v-if="this.$hasPerm('B008&6')">
          <voice-scene ref="voiceScene" v-bind:changeTabe="activeTab" :companySelected="company.companySelected" :groupSelected="group.groupSelected"></voice-scene>
        </el-tab-pane>
        <el-tab-pane label="场景模板" name="场景模板" v-if="this.$hasPerm('B008&8')">
          <scene-template ref="sceneTemplate"  v-bind:changeTabe="activeTab" :companySelected="company.companySelected" :groupSelected="group.groupSelected" :initTemplateFiled="initTemplateFiled" :addOrEditTemplate="addOrEditTemplate" :openAndCloseTemplate="openAndCloseTemplate"></scene-template>
        </el-tab-pane>
        <el-tab-pane label="场景流程" name="场景流程" v-if="this.$hasPerm('B008&9')">
          <panel ref="panel" v-bind:changeTabe="activeTab" :companySelected="company.companySelected" :groupSelected="group.groupSelected"></panel>
        </el-tab-pane>
        <el-tab-pane label="模板关键字列表" name="模板关键字列表" v-if="this.$hasPerm('B008&10')">
          <template-filed ref="informationFields" @showbox="toshow" v-bind:changeTabe="activeTab" :companySelected="company.companySelected" :groupSelected="group.groupSelected"></template-filed>
        </el-tab-pane>
        <!-- 关键字音频已移至系统配置菜单 -->
        <el-tab-pane label="标签列表" name="标签列表" v-if="this.$hasPerm('B008&3')">
          <label-list ref="labelList" v-bind:changeTabe="activeTab" :companySelected="company.companySelected" :caseStatusOption="caseStatusOption" :contactStatusOption="contactStatusOption" :labelMainOption="labelOption" :getLabelParams="getLabelParams"></label-list>
        </el-tab-pane>
        <el-tab-pane label="案件状态" name="案件状态" v-if="this.$hasPerm('B008&4')">
          <case-status ref="caseStatus" v-bind:changeTabe="activeTab" :getCaseStatusParam="getCaseStatusParam" :caseStatusOption="caseStatusOption"></case-status>
        </el-tab-pane>
        <el-tab-pane label="联系人状态" name="联系人状态" v-if="this.$hasPerm('B008&5')">
          <contact-status ref="contactStatus" v-bind:changeTabe="activeTab" :getContactStatusParam="getContactStatusParam" :contactStatusOption="contactStatusOption"></contact-status>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="dialog">
      <!-- 策略配置弹窗 -->
      <el-dialog
        title="策略配置"
        :visible.sync="strategyConfigVisible"
        width="70%" ref="strategyConfigVisible">
        <div>
          <el-form size="small" label-width="100px">
            <template v-for="(item, index) in groupList">
              <template v-if="item.isMain == 1">
                <el-row class="sc-row" :gutter="25" :key="generator('mainStrategy',index)">
                  <el-col :span="5" class="sc-row__title">
                    <strong>{{item.groupName}}</strong>
                  </el-col>
                  <el-col :span="4" class="sc-row__title">
                    <el-form-item label="发送比例(%)">
                      <el-input  v-model="item.percentage" class="percent" size="small"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" class="sc-row__title">
                    <el-form-item label="首发方式">
                      <el-select size="small" class="percent" v-model="item.sendWay" @change="changeSendWay(item)">
                        <el-option
                          v-for="item in firstSendWays"
                          :key="item.ccChannel"
                          :label="item.channelName"
                          :value="item.ccChannel">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" class="sc-row__title">
                    <el-form-item label="首发模版">
                      <el-select size="small" class="percent" v-model="item.sendTemplateId" clearable filterable>
                        <el-option
                          v-for="m in item.templateList"
                          :key="m.id"
                          :label="m.name"
                          :value="m.id">
                          <template>
                            <el-tooltip placement="top" effect="light">
                              <div slot="content" v-html="m.contentShow === undefined || m.contentShow === null ? m.content : m.contentShow"></div>
                              <span>{{m.name}}</span>
                            </el-tooltip>
                          </template>
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>
              <template v-else-if="item.isMain == 2">
                <el-row class="sc-row" :gutter="24" :key="item.id">
                  <el-col :span="4" class="sc-row__title">
                    <strong>{{item.groupName}}</strong>
                  </el-col>
                  <el-col :span="18" class="sc-row__content">
                    <div class="send-percent">
                      <label>发送比例(%)：</label>
                      <el-input v-model="item.percentage" class="percent" size="small"></el-input>
                      <el-button type="primary" size="small" plain>调整评分区间</el-button>
                      <el-button type="primary" @click="addStrategyConfig(item)" size="small" plain>+</el-button>
                    </div>
                    <div class="score-table">
                      <table class="table border bordered">
                        <thead>
                        <th style="width: 300px;">评分区间</th>
                        <th>策略组</th>
                        <th>操作</th>
                        </thead>
                        <tbody>
                        <template v-for="(scoreItem, index) in scoreConfList">
                          <template v-if="scoreItem.type == 0">
                            <tr :key="generator('scoreSelect',index)">
                              <td>其它评分</td>
                              <td>
                                <el-select size="small" v-model="scoreItem.groupId">
                                  <el-option
                                    v-for="item in group.groupOption"
                                    :key="item.id"
                                    :label="item.groupName"
                                    :value="item.id">
                                  </el-option>
                                </el-select>
                              </td>
                              <td>
                              </td>
                            </tr>
                          </template>
                          <template v-else>
                            <tr :key="generator('scoreSelect',index)">
                              <td>
                                <el-slider
                                  v-model="scoreItem.strategyScore"
                                  range
                                  :min="0"
                                  :max="100">
                                </el-slider>
                              </td>
                              <td>
                                <el-select size="small" v-model="scoreItem.groupId">
                                  <el-option
                                    v-for="item in group.groupOption"
                                    :key="item.id"
                                    :label="item.groupName"
                                    :value="item.id">
                                  </el-option>
                                </el-select>
                              </td>
                              <td>
                                <el-button type="danger" @click="deleteStrategyConfig(scoreItem,index)" size="mini" icon="el-icon-delete" plain></el-button>
                              </td>
                            </tr>
                          </template>
                        </template>
                        </tbody>
                      </table>
                    </div>
                  </el-col>
                </el-row>
              </template>
              <template v-else>
                <el-row class="sc-row" :gutter="24" :key="generator('otherStrategy',index)">
                  <el-col :span="5" class="sc-row__title">
                    <el-input v-model="item.groupName" style="width: 120px;"></el-input>
                  </el-col>
                  <el-col :span="4" class="sc-row__content">
                    <el-form-item label="发送比例(%)">
                      <el-input  v-model="item.percentage" class="percent" size="small"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" class="sc-row__content">
                    <el-form-item label="首发方式">
                      <el-select size="small" class="percent" v-model="item.sendWay" @change="changeSendWay(item)">
                        <el-option
                          v-for="item in firstSendWays"
                          :key="item.ccChannel"
                          :label="item.channelName"
                          :value="item.ccChannel">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" class="sc-row__content">
                    <el-form-item label="首发模版">
                      <el-select size="small" class="percent" v-model="item.sendTemplateId" clearable filterable >
                        <el-option
                          v-for="m in item.templateList"
                          :key="m.id"
                          :label="m.name"
                          :value="m.id">
                          <template>
                            <el-tooltip placement="top" effect="light">
                              <div slot="content" v-html="m.contentShow"></div>
                              <span>{{m.name}}</span>
                            </el-tooltip>
                          </template>
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" class="sc-row__content">
                    <el-button @click="delStrategyGroup(item.id)" size="small">删除</el-button>
                    <el-button type="primary" @click="synStrategy(item.id)" size="small">同步到主策略</el-button>
                  </el-col>
                </el-row>
              </template>
            </template>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="strategyConfigVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="saveStrategyConfig" size="small">保存</el-button>
        </div>
      </el-dialog>

      <!-- 策略组路由弹窗 -->
      <el-dialog
        title="路由策略组配置"
        :visible.sync="strategyRouteConfigVisible"
        width="70%" ref="strategyRouteConfigVisible">
        <span style="color: #f5222d;">注意：如果定制了策略组查找案子，不能开启此功能，比如“得物营销”</span>
        <div>
          <el-form size="small" label-width="100px">
            <el-table :data="groupRouteList" style="width: 100%">
                <el-table-column prop="groupName" label="策略组名字" min-width="180"/>
                <el-table-column label="权重" min-width="180">
                  <template slot-scope="scope">
                    <el-input-number :value="scope.row.weight" v-model="scope.row.weight" :min=0 :max=100 :disabled="!scope.row.status"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="是否路由">
                  <template slot-scope="scope">
                    <el-switch
                      :value="scope.row.status"
                      v-model="scope.row.status"
                      active-color="#f6ac19"
                      inactive-color="#282828">
                    </el-switch>
                  </template>
                </el-table-column>
              </el-table>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="strategyRouteConfigVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="saveStrategyRouteConfig" size="small">保存</el-button>
        </div>
      </el-dialog>

      <!-- 添加策略组 -->
      <el-dialog
        title="添加策略组"
        :visible.sync="addStrategyVisible"
        width="40%">
        <div>
          <el-form size="small" label-width="140px">
            <el-form-item label="策略组名称">
              <el-input placeholder="请输入名称" v-model="addStrategyGroupReq.groupName"></el-input>
            </el-form-item>
             <el-form-item label="来源策略组公司">
              <el-select v-model="addStrategyGroupReq.sourceCompanyId" placeholder="请选择" @change="sourceCompanyChange" style="width: 100%;" filterable>
                <el-option
                  v-for="item in company.companyOption"
                  :key="item.id"
                  :label="item.companyName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
             <el-form-item label="来源策略组名称">
              <el-select v-model="addStrategyGroupReq.sourceGroupId" @change="addStrategyOfChangeSendWay()" placeholder="请选择" style="width: 100%;" filterable>
                <el-option
                  v-for="item in sourceGroup.groupOption"
                  :key="item.id"
                  :label="item.groupName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="首发发送方式">
              <el-select v-model="addStrategyGroupReq.sendWay" @change="addStrategyOfChangeSendWay()" placeholder="请选择" style="width: 100%;" filterable>
                <el-option
                  v-for="item in firstSendWays"
                  :key="item.ccChannel"
                  :label="item.channelName"
                  :value="item.ccChannel">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="首发模版">
              <el-select v-model="addStrategyGroupReq.sendTemplateId" placeholder="请选择" style="width: 100%;" filterable>
                <el-option
                  v-for="item in templateList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                  <template>
                    <el-tooltip placement="top" effect="light">
                      <div slot="content" v-html="item.contentShow === undefined || item.contentShow === null ? item.content : item.contentShow"></div>
                      <span>{{item.name}}</span>
                    </el-tooltip>
                  </template>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="每日短信上限">
              <el-input placeholder="请输入每日短信上限数量" v-model="addStrategyGroupReq.msgCeiling"></el-input>
            </el-form-item>
            <el-form-item label="每日语音接听上限">
              <el-input placeholder="请输入每日语音接听上限数量" v-model="addStrategyGroupReq.ivrCeiling"></el-input>
            </el-form-item>
            <el-form-item label="计算机器人接听:" v-if="this.$partB()">
              <el-tooltip content="呼叫上限是否剔除机器人接听" placement="top">
                <i class="el-icon-question" style="margin-right:5px;"></i>
              </el-tooltip>
              <el-switch v-model="addStrategyGroupReq.isCalculateRobot" active-color="#f6ac19" inactive-color="#282828">
              </el-switch>
              <el-input-number v-if="addStrategyGroupReq.isCalculateRobot" v-model="addStrategyGroupReq.robotLimitNum"   :min="0" :step="1" label="机器人接听上限"></el-input-number>
            </el-form-item>
            <el-form-item label="计算接通时长(秒)">
                <el-tooltip content="1.呼叫上限剔除接通时长范围,如配置为10,则呼叫上限中剔除接通时长为0-10秒(含)的轮次；2.配置为0或者为空,则不做剔除" placement="top">
                  <i class="el-icon-question" style="margin-right:5px;"></i>
                </el-tooltip>
                <el-input-number  v-model="addStrategyGroupReq.answerDuration"   :min="0" :step="1"  ></el-input-number>
            </el-form-item>
            <el-form-item label="每日语音发送上限">
              <el-input placeholder="请输入每日语音发送上限数量" v-model="addStrategyGroupReq.ivrSendCeiling"></el-input>
            </el-form-item>
            <el-form-item label="场景语音请求超时时间(秒):" v-if="this.$partB()">
              <el-input v-model="addStrategyGroupReq.sceneTimeout" type="number" min="20" max="90" placeholder="请输入场景语音请求超时时间20-90"></el-input>
            </el-form-item>
            <el-form-item label="是否重呼:" v-if="this.$partB()">&nbsp;&nbsp;&nbsp;
              <el-switch
                v-model="addStrategyGroupReq.isRetry"
                active-color="#f6ac19"
                inactive-color="#282828">
              </el-switch>
            </el-form-item>
            <el-form-item label="重呼次数:" v-if="this.$partB() && addStrategyGroupReq.isRetry">
              <el-input v-model="addStrategyGroupReq.retryCount" type="number" :min="0" :max="24" placeholder="请输入重呼次数"></el-input>
            </el-form-item>
            <el-form-item label="重呼间隔（分钟）:" v-if="this.$partB() && addStrategyGroupReq.isRetry">
              <el-input v-model="addStrategyGroupReq.retryInterval" type="number" :min="0" placeholder="请输入重呼间隔（分钟）"></el-input>
            </el-form-item>
            <el-form-item label="重呼条件:" v-if="this.$partB() && addStrategyGroupReq.isRetry">
              <el-input v-model="addStrategyGroupReq.retryCondition" type="textarea" :rows="2"  placeholder="请输入重呼条件，多个条件分号隔开"></el-input>
            </el-form-item>
            <el-form-item label="ivr是否重呼:" v-if="this.$partB()">&nbsp;&nbsp;&nbsp;
              <el-switch
                v-model="addStrategyGroupReq.ivrIsRetry"
                active-color="#f6ac19"
                inactive-color="#282828">
              </el-switch>
            </el-form-item>
            <el-form-item label="ivr重呼次数:" v-if="this.$partB() && addStrategyGroupReq.ivrIsRetry">
              <el-input v-model="addStrategyGroupReq.ivrRetryCount" type="number" :min="0" :max="24" placeholder="请输入ivr重呼次数"></el-input>
            </el-form-item>
            <el-form-item label="ivr重呼条件:" v-if="this.$partB() && addStrategyGroupReq.ivrIsRetry">
              <el-input v-model="addStrategyGroupReq.ivrRetryCondition" type="textarea" :rows="2"  placeholder="请输入ivr重呼条件，多个条件分号隔开"></el-input>
            </el-form-item>
            <el-form-item label="短信是否重发:" v-if="this.$partB()">&nbsp;&nbsp;&nbsp;
              <el-switch v-model="addStrategyGroupReq.msgIsRetry" active-color="#f6ac19" inactive-color="#282828">
              </el-switch>
            </el-form-item>
            <el-form-item label="短信重发次数:" v-if="this.$partB() && addStrategyGroupReq.msgIsRetry">
              <el-input v-model="addStrategyGroupReq.msgRetryCount" type="number" :min="0" :max="24" placeholder="请输入短信重发次数"></el-input>
            </el-form-item>
            <!-- <el-form-item label="短信重发时短信状态:" v-if="this.$partB() && addStrategyGroupReq.msgIsRetry">
              <el-select multiple v-model="msgIsRetryLabelData" placeholder="请选择" style="width: 100%;" >
                  <el-option
                    v-for="item in msgRetryStatusTypes"
                    :key="item.modelCode"
                    :label="item.modelName"
                    :value="item.modelCode">
                  </el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item label="短信重发时效:" v-if="this.$partB() && addStrategyGroupReq.msgIsRetry">
                <el-input v-model="addStrategyGroupReq.msgRetryEffectiveTime" type="number" :min="0" max="1000000" placeholder="请输入短信重发时效">分钟</el-input>
            </el-form-item>
            <el-form-item label="是否开启mock:" v-if="this.$hasPerm('B008&12-1')">&nbsp;&nbsp;&nbsp;
              <el-switch
                v-model="mockConfInfo.isMock"
                active-color="#f6ac19"
                inactive-color="#282828">
              </el-switch>
            </el-form-item>
            <el-form-item label="电话状态:" v-if="this.$hasPerm('B008&12-1') && mockConfInfo.isMock">
              <el-input v-model="mockConfInfo.mobileStatus" type="textarea" :rows="2" placeholder="请输入电话状态，多个条件封号隔开"></el-input>
            </el-form-item>
            <el-form-item label="mock的万分比:" v-if="this.$hasPerm('B008&12-1') && mockConfInfo.isMock">
              <el-input v-model="mockConfInfo.rate" type="number" min="0" max="10000" placeholder="请输入mock百分比0-10000"></el-input>
            </el-form-item>
            <el-form-item label="最大接听率:" v-if="this.$hasPerm('B008&12-1') && mockConfInfo.isMock">
              <el-input v-model="mockConfInfo.maxAnswerRate" type="number" min="0" max="100" placeholder="请输入最大接听率百分比0-100"></el-input>
            </el-form-item>
            <el-form-item label="是否mock详情:" v-if="this.$hasPerm('B008&12-1') && mockConfInfo.isMock">&nbsp;&nbsp;&nbsp;
              <el-switch
                v-model="mockConfInfo.isConfDetails"
                active-color="#f6ac19"
                inactive-color="#282828">
              </el-switch>
              <el-button type="primary" style="margin-bottom: 20px; margin-left: 60%;" size="mini" round @click="addRow" v-if="this.$hasPerm('B008&12-1') && mockConfInfo.isConfDetails">添加句</el-button>
              <template v-if="this.$hasPerm('B008&12-1') && mockConfInfo.isConfDetails">
                <div>
                  <el-table :data="mockConfInfo.confDetails" style="width: 100%">
                    <el-table-column prop="number" label="句序" width="100"></el-table-column>
                    <el-table-column prop="weight" label="权重" width="150">
                      <template slot-scope="scope">
                        <el-input-number :min="1" :max="100" v-model="scope.row.weight"></el-input-number>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button type="text" @click="deleteRow(scope.$index)">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </template>
            </el-form-item>
            <el-form-item label="预测试外呼配置:" v-if="this.$partB()">
              <el-input v-model="addStrategyGroupReq.pretestConf" type="textarea" :rows="2" placeholder="请输入预测试外呼配置"></el-input>
            </el-form-item>
            <el-form-item label="使用的关键字:" v-if="this.$partB()">
              <el-input v-model="addStrategyGroupReq.keywords" type="textarea" :rows="2" placeholder="请输入使用的关键字"></el-input>
            </el-form-item>
            <el-form-item label="条件路由" v-if="this.$hasPerm('B033&1')">
              <el-select v-model="addStrategyGroupReq.routeConId" placeholder="请选择" style="width: 100%;" filterable clearable>
                <el-option
                  v-for="item in routeConOption"
                  :key="item.id"
                  :label="item.confName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addStrategyVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="addStrategyGroup" size="small">保存</el-button>
        </div>
      </el-dialog>

      <!-- 编辑策略组 -->
      <el-dialog
        title="编辑策略组"
        :visible.sync="updateGroupVisible"
        width="40%">
        <div>
          <el-form size="small" label-width="140px">
            <el-form-item label="策略组名称">
              <el-input v-if="updateGroupReq.groupName === '主策略' || updateGroupReq.groupName === '主策略组'" placeholder="请输入策略组名称" v-model="updateGroupReq.groupName" :disabled="true"></el-input>
              <el-input v-else placeholder="请输入策略组名称" v-model="updateGroupReq.groupName"></el-input>
            </el-form-item>
            <el-form-item label="首发发送方式">
              <el-select v-model="updateGroupReq.sendWay" @change="updateStrategyOfChangeSendWay()" placeholder="请选择" style="width: 100%;" filterable>
                <el-option
                  v-for="item in firstSendWays"
                  :key="item.ccChannel"
                  :label="item.channelName"
                  :value="item.ccChannel">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="首发模版">
              <el-select v-model="updateGroupReq.sendTemplateId" placeholder="请选择" style="width: 100%;" clearable  filterable>
                <el-option
                  v-for="item in templateList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                  <template>
                    <el-tooltip placement="top" effect="light">
                      <div slot="content" v-html="item.contentShow ? item.contentShow : item.content"></div>
                      <span>{{item.name}}</span>
                    </el-tooltip>
                  </template>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="每日短信上限">
              <el-input placeholder="请输入每日短信上限数量" v-model="updateGroupReq.msgCeiling"></el-input>
            </el-form-item>
            <el-form-item label="每日语音接听上限">
              <el-input placeholder="请输入每日语音接听上限数量" v-model="updateGroupReq.ivrCeiling"></el-input>
            </el-form-item>
            <el-form-item label="计算机器人接听:" v-if="this.$partB()">
              <el-tooltip content="呼叫上限是否剔除机器人接听" placement="top">
                <i class="el-icon-question" style="margin-right:5px;"></i>
              </el-tooltip>
              <el-switch v-model="updateGroupReq.isCalculateRobot" active-color="#f6ac19" inactive-color="#282828">
              </el-switch>
              <el-input-number v-if="updateGroupReq.isCalculateRobot" v-model="updateGroupReq.robotLimitNum"   :min="0" :step="1" label="机器人接听上限"></el-input-number>
            </el-form-item>
            <el-form-item label="计算接通时长(秒):">
                <el-tooltip content="1.呼叫上限剔除接通时长范围,如配置为10,则呼叫上限中剔除接通时长为0-10秒(含)的轮次；2.配置为0或者为空,则不做剔除" placement="top">
                  <i class="el-icon-question" style="margin-right:5px;"></i>
                </el-tooltip>
                <el-input-number  v-model="updateGroupReq.answerDuration"   :min="0" :step="1"  ></el-input-number>
            </el-form-item>
            <el-form-item label="每日语音发送上限">
              <el-input placeholder="请输入每日语音发送上限数量" v-model="updateGroupReq.ivrSendCeiling"></el-input>
            </el-form-item>
            <el-form-item label="场景语音请求超时时间(秒):" v-if="this.$partB()">
              <el-input v-model="updateGroupReq.sceneTimeout" type="number" min="20" max="90" placeholder="请输入场景语音请求超时时间20-90"></el-input>
            </el-form-item>
            <el-form-item label="是否重呼:" v-if="this.$partB()">&nbsp;&nbsp;&nbsp;
              <el-switch
                v-model="updateGroupReq.isRetry"
                active-color="#f6ac19"
                inactive-color="#282828">
              </el-switch>
            </el-form-item>
            <el-form-item label="未振铃:" v-if="this.$partB() && updateGroupReq.isRetry">
              <el-tooltip content="只允许未振铃重呼" placement="top">
                <i class="el-icon-question" style="margin-right:5px;"></i>
              </el-tooltip>
              <el-switch
                v-model="updateGroupReq.retryNoRingtone"
                :active-value="1"
                :inactive-value="0"
                active-text="开启"
                inactive-text="关闭">
              </el-switch>
            </el-form-item>
            <el-form-item label="重呼次数:" v-if="this.$partB() && updateGroupReq.isRetry">
              <el-input v-model="updateGroupReq.retryCount" type="number" :min="0" :max="24" placeholder="请输入重呼次数"></el-input>
            </el-form-item>
            <el-form-item label="重呼间隔（分钟）:" v-if="this.$partB() && updateGroupReq.isRetry">
              <el-input v-model="updateGroupReq.retryInterval" type="number" :min="0" placeholder="请输入重呼间隔（分钟）"></el-input>
            </el-form-item>
            <el-form-item label="重呼条件:" v-if="this.$partB() && updateGroupReq.isRetry">
              <el-input v-model="updateGroupReq.retryCondition" type="textarea" :rows="2"  placeholder="请输入重呼条件，多个条件分号隔开"></el-input>
            </el-form-item>
            <el-form-item label="ivr是否重呼:" v-if="this.$partB()">&nbsp;&nbsp;&nbsp;
              <el-switch
                v-model="updateGroupReq.ivrIsRetry"
                active-color="#f6ac19"
                inactive-color="#282828">
              </el-switch>
            </el-form-item>
            <el-form-item label="ivr重呼次数:" v-if="this.$partB() && updateGroupReq.ivrIsRetry">
              <el-input v-model="updateGroupReq.ivrRetryCount" type="number" :min="0" :max="24" placeholder="请输入ivr重呼次数"></el-input>
            </el-form-item>
            <el-form-item label="ivr重呼条件:" v-if="this.$partB() && updateGroupReq.ivrIsRetry">
              <el-input v-model="updateGroupReq.ivrRetryCondition" type="textarea" :rows="2"  placeholder="请输入ivr重呼条件，多个条件分号隔开"></el-input>
            </el-form-item>
              <el-form-item label="短信是否重发:" v-if="this.$partB()">&nbsp;&nbsp;&nbsp;
                <el-switch v-model="updateGroupReq.msgIsRetry" active-color="#f6ac19" inactive-color="#282828">
                </el-switch>
              </el-form-item>
              <el-form-item label="短信重发次数:" v-if="this.$partB() && updateGroupReq.msgIsRetry">
                <el-input v-model="updateGroupReq.msgRetryCount" type="number" :min="0" :max="24" placeholder="请输入短信重发次数"></el-input>
              </el-form-item>
              <!-- <el-form-item label="短信重发时短信状态:" v-if="this.$partB() && updateGroupReq.msgIsRetry">
                <el-select v-model="msgIsRetryLabelData" multiple placeholder="请选择" style="width: 100%;">
                    <el-option
                      v-for="item in msgRetryStatusTypes"
                      :key="item.modelCode"
                      :label="item.modelName"
                      :value="item.modelCode">
                    </el-option>
                  </el-select>
              </el-form-item> -->
              <el-form-item label="短信重发时效:" v-if="this.$partB() && updateGroupReq.msgIsRetry">
                  <el-input v-model="updateGroupReq.msgRetryEffectiveTime" type="number" :min="0" max="1000000" placeholder="请输入短信重发时效">分钟</el-input>
              </el-form-item>
            <el-form-item label="是否开启mock:" v-if="this.$hasPerm('B008&12-1')">&nbsp;&nbsp;&nbsp;
              <el-switch
                v-model="mockConfInfo.isMock"
                active-color="#f6ac19"
                inactive-color="#282828">
              </el-switch>
            </el-form-item>
            <el-form-item label="电话状态:" v-if="mockConfInfo.isMock && this.$hasPerm('B008&12-1')">
              <el-input v-model="mockConfInfo.mobileStatus" type="textarea" :rows="2" placeholder="请输入电话状态，多个条件封号隔开"></el-input>
            </el-form-item>
            <el-form-item label="mock的万分比:" v-if="mockConfInfo.isMock  && this.$hasPerm('B008&12-1')">
              <el-input v-model="mockConfInfo.rate" type="number" min="0" max="10000" placeholder="请输入mock百分比0-10000"></el-input>
            </el-form-item>
            <el-form-item label="最大接听率:" v-if="mockConfInfo.isMock && this.$hasPerm('B008&12-1')">
              <el-input v-model="mockConfInfo.maxAnswerRate" type="number" min="0" max="100" placeholder="请输入最大接听率百分比0-100"></el-input>
            </el-form-item>
            <el-form-item label="是否mock详情:" v-if="this.$hasPerm('B008&12-1') && mockConfInfo.isMock">&nbsp;&nbsp;&nbsp;
              <el-switch
                v-model="mockConfInfo.isConfDetails"
                active-color="#f6ac19"
                inactive-color="#282828">
              </el-switch>
              <el-button type="primary" style="margin-bottom: 20px; margin-left: 60%;" size="mini" round @click="addRow" v-if="this.$hasPerm('B008&12-1') && mockConfInfo.isConfDetails">添加句</el-button>
              <template v-if="this.$hasPerm('B008&12-1') && mockConfInfo.isConfDetails">
                <div>
                  <el-table :data="mockConfInfo.confDetails" style="width: 100%">
                    <el-table-column prop="number" label="句序" width="100"></el-table-column>
                    <el-table-column prop="weight" label="权重" width="150">
                      <template slot-scope="scope">
                        <el-input-number :min="1" :max="100" v-model="scope.row.weight"></el-input-number>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button type="text" @click="deleteRow(scope.$index)">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </template>
            </el-form-item>
            <el-form-item label="预测试外呼配置:" v-if="this.$partB()">
              <el-input v-model="updateGroupReq.pretestConf" type="textarea" :rows="2" placeholder="请输入预测试外呼配置"></el-input>
            </el-form-item>
            <el-form-item label="使用的关键字:" v-if="this.$partB()">
              <el-input v-model="updateGroupReq.keywords" type="textarea" :rows="2" placeholder="请输入使用的关键字"></el-input>
            </el-form-item>
            <el-form-item label="条件路由" v-if="this.$hasPerm('B033&1')">
              <el-select v-model="updateGroupReq.routeConId" placeholder="请选择" style="width: 100%;" filterable clearable>
                <el-option
                  v-for="item in routeConOption"
                  :key="item.id"
                  :label="item.confName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="updateGroupVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="updateStrategyGroup" size="small">保存</el-button>
        </div>
      </el-dialog>

      <!-- 更新策略和模板 -->
       <el-dialog
        title="更新策略和模板"
        :visible.sync="updateStrategyVisible"
        width="30%">
        <div>
          <el-form size="small" label-width="140px">
            <el-form-item label="对象公司">
              <el-select v-model="updateCollectAndTemplateReq.toCompany" filterable placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in company.companyOption"
                  :key="item.id"
                  :label="item.companyName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
             <el-form-item label="选择更新方式">
              <el-select v-model="updateCollectAndTemplateReq.changeWay" filterable placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in changeWayOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
             <el-form-item label="策略模板来源公司">
              <el-select v-model="updateCollectAndTemplateReq.sourceCompany" filterable placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in company.companyOption"
                  :key="item.id"
                  :label="item.companyName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="updateStrategyVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="updateCollectAndTemplate" size="small">保存</el-button>
        </div>
      </el-dialog>
      <!-- 批量更新模板 -->
      <el-dialog
        title="批量更新模板"
        :visible.sync="updateTemplateVisible"
        width="40%">
        <div>
          <el-form size="small" label-width="140px">
            <el-form-item label="更新公司">
              <el-select v-model="updateCompany" style="width: 100%;" placeholder="请选择" multiple collapse-tags filterable @change="updateTemplateCompanyChange">
                <el-option
                  v-for="item in company.companyOption"
                  :key="item.id"
                  :label="item.companyName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
             <el-form-item label="策略组">
              <el-select v-model="updateGroupId" style="width: 100%;" multiple collapse-tags filterable placeholder="请选择（非必选项）">
                <el-option
                  v-for="item in groupIdList"
                  :key="item.id"
                  :label="item.companyName + '-' + item.groupName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="原始字段">
              <el-input placeholder="请输入内容" v-model="updateTemplateReq.originalContent"></el-input>
            </el-form-item>
            <el-form-item label="更新字段">
              <el-input placeholder="请输入内容" v-model="updateTemplateReq.updateContent"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="updateTemplateVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="updateTemplate" size="small">保存</el-button>
        </div>
      </el-dialog>

      <!-- 批量更新模板 -->
      <el-dialog
        title="批量更新模板"
        :visible.sync="submitUpdateTemplateVisible"
        width="40%">
        <div>
          <span>{{updateTemplateMessage}}</span>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="submitUpdateTemplateVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="submitUpdateTemplate" size="small">保存</el-button>
        </div>
      </el-dialog>
    </div>
    <add-template ref="addTemplate" :search="search"></add-template>
     <!-- 策略组配置 -->
    <group-config ref="groupConfig" :company="company"></group-config>
  </div>
</template>
<script>
import lodash from 'lodash';
import sendRule from './send_rule';
import voiceTemplateList from './voice_template_list';
import msgTemplateList from './msg_template_list';
import caseStatus from './case_status';
import contactStatus from './contact_status';
import labelList from './label_list';
import addTemplate from './add_template';
import strategyOverview from './strategy_overview';
import ivoiceTemplateList from './ivoice_template_list';
import panel from './panel';
import voiceScene from './voice_scene';
import sceneTemplate from './scene_template';
import templateFiled from './template_filed';
import groupConfig from './group_config';

export default {
  data() {
    return {
      activeTab: '策略总览',
      startTime: '',
      updateCompany: [],
      firstSendWays: [],
      company: {
        companySelected: '',
        companyOption: [],
        strategyPoint: ''
      },
      group: {
        groupSelected: '',
        groupOption: []
      },
      sourceGroup: {
        groupSelected: '',
        groupOption: []
      },
      routeConOption: [],
      changeWayOption: [
        {
          value: '0',
          label: '重置主策略及模板'
        },
        {
          value: '1',
          label: '更新主策略及模板'
        },
        {
          value: '2',
          label: '更新主策略模板'
        }
      ],
      otherScore: '',
      score: [25, 50],
      strategyConfigVisible: false,
      strategyRouteConfigVisible: false,
      addStrategyVisible: false,
      updateStrategyVisible: false,
      updateTemplateVisible: false,
      submitUpdateTemplateVisible: false,
      groupReq: {
        companyId: ''
      },
      groupRouteReq: {
        companyId: '',
        groupId: ''
      },
      routeConReq: {
        companyId: ''
      },
      addStrategyGroupReq: {
        companyId: '',
        groupName: '',
        sourceCompanyId: '',
        sourceGroupId: '',
        sendWay: '',
        sendTemplateId: '',
        msgCeiling: null,
        ivrCeiling: null,
        sceneTimeout: 60,
        isCalculateRobot: null,
        answerDuration: null,
        robotLimitNum: 0,
        ivrSendCeiling: null,
        isRetry: null,
        retryCount: null,
        retryCondition: null,
        ivrIsRetry: null,
        ivrRetryCount: null,
        ivrRetryCondition: null,
        msgIsRetry: true,
        msgRetryCount: 10,
        msgRetryStatus: null,
        msgRetryEffectiveTime: 40,
        keywords: null,
        routeConId: null,
        mockConf: null,
        retryInterval: null,
        pretestConf: null
      },
      mockConfInfo: {},
      mockConfInfoInit: {
        isMock: false,
        mobileStatus: 'NORMAL_TEMPORARY_FAILURE;UNALLOCATED_NUMBER;CALL_REJECTED;INVALID_NUMBER_FORMAT;SERVICE_NOT_IMPLEMENTED;ORIGINATOR_CANCEL;NO_USER_RESPONSE;RECOVERY_ON_TIMER_EXPIRE;NORMAL_CLEARING;NO_ANSWER;NORMAL_UNSPECIFIED',
        rate: 0,
        maxAnswerRate: 0,
        isConfDetails: false,
        confDetails: []
      },
      updateCollectAndTemplateReq: {
        toCompany: '',
        changeWay: '',
        sourceCompany: ''
      },
      updateTemplateReq: {
        companyIds: '',
        originalContent: '',
        updateContent: ''
      },
      updateTemplateMessage: '',
      groupList: [],
      groupRouteList: [],
      scoreConfList: [],
      saveScoreDeployStrategyReq: {
        groupList: [],
        scoreConfList: [],
        deleteList: []
      },
      queryTemplateReq: {
        type: '',
        groupId: '',
        companyId: ''
      },
      changeStrategyReq: {
        oldMainGroupId: '',
        selectedGroupId: ''
      },
      templateOperType: {
        addMsg: 'addMsg',
        addVoice: 'addVoice',
        addIvoice: 'addIvoice',
        add: 'add',
        edit: 'edit',
        addChildTemplate: 'addChildTemplate',
        addSceneTemplate: 'addSceneTemplate'
      },
      caseStatusOption: [],
      contactStatusOption: [],
      labelOption: [],
      templateMsgOption: [],
      templateVoiceOption: [],
      templateIVoiceOption: [],
      templateSVoiceOption: [],
      templateType: {
        tempTypeMsg: 'msg',
        tempTypeVoice: 'ivr',
        tempTypeIVoice: 'iVoice',
        tempTypeScene: 'svoice'
      },
      templateList: [],
      contactStatusType: {
        benrendianhua: 'benrendianhuaContactStatus',
        zhixidianhua: 'zhixidianhuaContactStatus'
      },
      groupIdList: [],
      updateGroupId: [],
      updateGroupVisible: false,
      updateGroupReq: {
        companyId: null,
        groupId: null,
        groupName: null,
        sendWay: null,
        sendTemplateId: null,
        msgCeiling: null,
        ivrCeiling: null,
        sceneTimeout: 60,
        isCalculateRobot: null,
        answerDuration: null,
        robotLimitNum: 0,
        ivrSendCeiling: null,
        isRetry: null,
        retryCount: null,
        retryCondition: null,
        retryNoRingtone: null,
        ivrIsRetry: null,
        ivrRetryCount: null,
        ivrRetryCondition: null,
        msgIsRetry: null,
        msgRetryCount: 10,
        msgRetryStatus: null,
        msgRetryEffectiveTime: 40,
        keywords: null,
        routeConId: null,
        mockConf: null,
        retryInterval: null,
        pretestConf: null
      },
      msgRetryStatusTypes: [],
      msgIsRetryLabelData: [],
      initMsgIsRetryLabelData: []
    };
  },
  mounted() {
    this.getCompanyOptionList();
    // if (this.$hasPerm('B008&4')) this.caseStatusClick();
    if (this.$hasPerm('B008&5')) this.contactStatusClick();
    this.$refs.sendRule.getMobileStatusOption();
    this.getFirstSendWay();
    this.initTemplateFiled(this.templateOperType);
    this.getCaseStatusParam();
    this.getContactStatusParam();
    this.getMsgRetryStatusTypes();
    // 因为子组件调父组件，跨了文件，这样写更简单，不需要一级级传方法，但要保证父级的'templateHadChange'唯一
    // window.eventBus.$on('templateHadChange', () => {
    //   this.initTemplateList();
    // });
  },
  methods: {
    toshow(activeTab) {
      this.activeTab = activeTab;
    },
    // sendRuleClick() {
    //   this.$refs.sendRule.getSengRuleDataByFirst(this.company.companySelected, this.company.strategyPoint, this.group.groupSelected, 1);
    // },
    voiceTemplateListClick() {
      this.$refs.voiceTemplateList.getDataByFirst(this.company.companySelected, this.group.groupSelected, 1);
    },
    sceneTemplateListClick() {
      this.$refs.sceneTemplate.getDataByFirst(this.company.companySelected, this.group.groupSelected, 1);
    },
    msgTemplateListClick() {
      this.$refs.msgTemplateList.getDataByFirst(this.company.companySelected, this.group.groupSelected, 1);
    },
    labelListClick() {
      this.$refs.labelList.getDataByFirst(this.company.companySelected, 1);
    },
    caseStatusClick() {
      this.$refs.caseStatus.getDataByFirst(1);
    },
    contactStatusClick() {
      this.$refs.contactStatus.getDataByFirst(1);
    },
    strategyOverviewClick() {
      this.$refs.strategyOverview.getData(this.company.companySelected);
    },
    // 公司列表
    getCompanyOptionList() {
      this.$ajax({
        url: '/company/getCompanyListJudgeRole',
        method: 'get'
      }).then((res) => {
        this.company.companyOption = res.data;
        // 获取缓存
        const sessionOverview = JSON.parse(sessionStorage.getItem('strategyOverview'));
        if (sessionOverview === null) {
          this.activeTab = '策略总览';
          this.company.companySelected = this.$account().companyId;
        } else {
          this.activeTab = '策略明细';
          this.company.companySelected = sessionOverview.companyId;
        }
        res.data.forEach((element) => {
          if (element.id === this.company.companySelected) {
            this.company.strategyPoint = element.strategyPoint;
            return false;
          }
          return true;
        });
        this.companyChange();
      });
    },
    getFirstSendWay() {
      this.$ajax({
        url: '/callPlatform/getFirstSendWay',
        method: 'post'
      }).then((res) => {
        this.firstSendWays = res.data.sendWayList;
      });
    },
    companyChange() {
      // 查对应的策略组
      this.groupReq.companyId = this.company.companySelected;
      this.getGroupOptionList(this.groupReq);
      // this.labelListClick();
      this.getLabelParams();
      this.queryAllGroupsOfThisCompany(this.groupReq);

      this.initTemplateFiled(this.templateOperType);
      this.getRouteConOption();
    },
    sourceCompanyChange() {
      this.groupReq.companyId = this.addStrategyGroupReq.sourceCompanyId;
      this.$ajax({
        url: '/strategy/selectAllGroupsByCompanyIdOfUser',
        method: 'POST',
        data: this.groupReq
      }).then((res) => {
        this.sourceGroup.groupOption = res.data;
        this.addStrategyGroupReq.sourceGroupId = res.data[0].id;
        this.addStrategyOfChangeSendWay();
      });
    },
    strategyConfig() {
      this.strategyConfigVisible = true;
      this.groupList.forEach((item) => {
        if (item.isMain === 1) {
          this.changeSendWay(item);
        } else if (item.isMain !== 1 && item.isMain !== 2) {
          this.changeSendWay(item);
        }
      });
    },
    strategyRouteConfig(item) {
      this.strategyRouteConfigVisible = true;
      this.getGroupRouteList(item);
    },
    getGroupRouteList(item) {
      this.groupRouteList = [];
      this.groupRouteReq.companyId = this.company.companySelected;
      this.groupRouteReq.groupId = item.groupId;
      this.$ajax({
        url: '/strategy/getGroupRouteConfig',
        method: 'POST',
        data: this.groupRouteReq
      }).then((res) => {
        this.groupRouteList = res.data;
      });
    },
    getRouteConOption() {
      this.routeConReq.companyId = this.company.companySelected;
      this.$ajax({
        method: 'get',
        url: '/conditionRoute/listByCompanyId',
        params: this.routeConReq
      }).then((res) => {
        this.routeConOption = res.data;
      });
    },
    saveStrategyRouteConfig() {
      const list = [];
      this.groupRouteList.forEach((item) => {
        if (item.status) {
          list.push(item);
        }
      });
      const reqBody = {
        companyId: this.company.companySelected,
        groupId: this.groupRouteReq.groupId,
        conf: list
      };
      this.$ajax({
        url: '/strategy/saveStrategyRouteConfig',
        data: reqBody,
        prompt: true
      }).then(
        this.strategyRouteConfigVisible = false
      );
    },
    changeSendWay(item) {
      const req = {};
      req.groupId = item.id;
      req.companyId = item.companyId;
      req.type = item.id;
      if (item.sendWay === 'ivr') {
        req.type = 'ivr';
      } else if (item.sendWay === 'ivoice') {
        req.type = 'ivoice';
      } else if (item.sendWay === 'svoice') {
        req.type = 'svoice';
      } else {
        req.type = 'msg';
      }
      if (item.sendWay !== 'svoice') {
        this.$ajax({
          url: '/robotCase/getTemplateByCompanyId',
          data: req
        }).then((res) => {
          item.templateList = res.data;
        });
      } else {
        this.$ajax({
          url: '/scene/getSceneParam',
          method: 'POST',
          data: req
        }).then((res) => {
          item.templateList = res.data;
        });
      }
    },
    addStrategyOfChangeSendWay() {
      this.queryTemplateReq.groupId = this.addStrategyGroupReq.sourceGroupId;
      this.queryTemplateReq.companyId = this.addStrategyGroupReq.sourceCompanyId;
      this.queryTemplateReq.type = 'ivr';
      if (this.addStrategyGroupReq.sendWay === 'ivr') {
        this.queryTemplateReq.type = 'ivr';
      } else if (this.addStrategyGroupReq.sendWay === 'ivoice') {
        this.queryTemplateReq.type = 'ivoice';
      } else if (this.addStrategyGroupReq.sendWay === 'svoice') {
        this.queryTemplateReq.type = 'svoice';
      } else {
        this.queryTemplateReq.type = 'msg';
      }
      if (this.queryTemplateReq.type !== 'svoice') {
        this.$ajax({
          url: '/robotCase/getTemplateByCompanyId',
          data: this.queryTemplateReq
        }).then((res) => {
          this.templateList = res.data;
        });
      } else {
        this.$ajax({
          url: '/scene/getSceneParam',
          method: 'POST',
          data: this.queryTemplateReq
        }).then((res) => {
          this.templateList = res.data;
        });
      }
    },
    getGroupOptionList(dataReq) {
      this.$ajax({
        url: '/strategy/selectAllGroupsByCompanyIdOfUser',
        method: 'POST',
        data: dataReq
      }).then((res) => {
        this.group.groupOption = res.data;
        // 获取缓存
        const sessionOverview = JSON.parse(sessionStorage.getItem('strategyOverview'));
        if (sessionOverview === null) {
          this.group.groupSelected = res.data[0].id;
        } else {
          this.group.groupSelected = sessionOverview.groupId;
          sessionStorage.removeItem('strategyOverview');
        }
        this.sourceGroup.groupOption = res.data;
        this.sourceGroup.groupSelected = res.data[0].id;
        // this.sendRuleClick();
        // this.voiceTemplateListClick();
        // this.msgTemplateListClick();
        this.initTemplateList();
        this.strategyOverviewClick();
      });
    },
    groupChange() {
      // this.sendRuleClick();
      // this.voiceTemplateListClick();
      // this.msgTemplateListClick();
      this.initTemplateList();
    },
    addStrategy(group) {
      if (group) {
        this.addStrategyGroupReq.sourceGroupId = group.groupId;
        this.addStrategyGroupReq.msgCeiling = group.msgCeiling;
        this.addStrategyGroupReq.ivrCeiling = group.ivrCeiling;
        this.addStrategyGroupReq.sceneTimeout = group.sceneTimeout;
        this.addStrategyGroupReq.isCalculateRobot = group.isCalculateRobot;
        this.addStrategyGroupReq.answerDuration = group.answerDuration;
        this.addStrategyGroupReq.robotLimitNum = group.robotLimitNum;
        this.addStrategyGroupReq.ivrSendCeiling = group.ivrSendCeiling;
        this.addStrategyGroupReq.isRetry = group.isRetry;
        this.addStrategyGroupReq.retryCount = group.retryCount;
        this.addStrategyGroupReq.retryCondition = group.retryCondition;
        this.addStrategyGroupReq.ivrIsRetry = group.ivrIsRetry;
        this.addStrategyGroupReq.ivrRetryCount = group.ivrRetryCount;
        this.addStrategyGroupReq.ivrRetryCondition = group.ivrRetryCondition;
        this.addStrategyGroupReq.msgIsRetry = group.msgIsRetry;
        this.addStrategyGroupReq.msgRetryStatus = group.msgRetryStatus;
        if (group.msgIsRetry) {
          if (group.msgRetryStatus) {
            this.msgIsRetryLabelData = group.msgRetryStatus.split(',');
          } else {
            this.msgIsRetryLabelData = [];
          }
          this.addStrategyGroupReq.msgRetryEffectiveTime = group.msgRetryEffectiveTime;
          this.addStrategyGroupReq.msgRetryCount = group.msgRetryCount;
        } else {
          this.msgIsRetryLabelData = this.initMsgIsRetryLabelData;
          this.addStrategyGroupReq.msgRetryEffectiveTime = 40;
          this.addStrategyGroupReq.msgRetryCount = 10;
        }
        this.addStrategyGroupReq.keywords = group.keywords;
        this.addStrategyGroupReq.routeConId = group.routeConId;
        this.addStrategyGroupReq.retryInterval = group.retryInterval;
        this.addStrategyGroupReq.pretestConf = group.pretestConf;
      } else {
        this.msgIsRetryLabelData = this.initMsgIsRetryLabelData;
        this.addStrategyGroupReq.msgRetryEffectiveTime = 40;
        this.addStrategyGroupReq.sourceGroupId = this.group.groupSelected;
        this.addStrategyGroupReq.msgRetryCount = 10;
        this.addStrategyGroupReq.sceneTimeout = 60;
      }
      this.addStrategyGroupReq.sourceCompanyId = this.company.companySelected;
      this.addStrategyGroupReq.companyId = this.company.companySelected;
      this.mockConfInfo = lodash.cloneDeep(this.mockConfInfoInit);
      this.addStrategyVisible = true;
    },
    onRefresList(group) {
      this.addStrategy(group);
    },
    updateGroup(group) {
      this.updateGroupReq.groupId = group.groupId;
      this.updateGroupReq.groupName = group.groupName;
      this.updateGroupReq.sendWay = group.sendWay;
      this.updateGroupReq.companyId = this.company.companySelected;
      this.updateStrategyOfChangeSendWay();
      this.updateGroupReq.sendTemplateId = group.sendTemplateId;
      this.updateGroupReq.msgCeiling = group.msgCeiling;
      this.updateGroupReq.ivrCeiling = group.ivrCeiling;
      this.updateGroupReq.sceneTimeout = group.sceneTimeout;
      this.updateGroupReq.isCalculateRobot = group.isCalculateRobot;
      this.updateGroupReq.answerDuration = group.answerDuration;
      this.updateGroupReq.robotLimitNum = group.robotLimitNum;
      this.updateGroupReq.ivrSendCeiling = group.ivrSendCeiling;
      this.updateGroupReq.isRetry = group.isRetry;
      this.updateGroupReq.retryCount = group.retryCount;
      this.updateGroupReq.retryCondition = group.retryCondition;
      this.updateGroupReq.retryNoRingtone = group.retryNoRingtone;
      this.updateGroupReq.ivrIsRetry = group.ivrIsRetry;
      this.updateGroupReq.ivrRetryCount = group.ivrRetryCount;
      this.updateGroupReq.ivrRetryCondition = group.ivrRetryCondition;
      this.updateGroupReq.msgIsRetry = group.msgIsRetry;
      this.updateGroupReq.msgRetryStatus = group.msgRetryStatus;
      this.updateGroupReq.retryInterval = group.retryInterval;
      this.updateGroupReq.pretestConf = group.pretestConf;
      if (group.msgIsRetry) {
        this.updateGroupReq.msgRetryEffectiveTime = group.msgRetryEffectiveTime;
        this.updateGroupReq.msgRetryCount = group.msgRetryCount;
        if (group.msgRetryStatus) {
          this.msgIsRetryLabelData = group.msgRetryStatus.split(',');
        } else {
          this.msgIsRetryLabelData = [];
        }
      } else {
        this.msgIsRetryLabelData = this.initMsgIsRetryLabelData;
        this.updateGroupReq.msgRetryEffectiveTime = 40;
        this.updateGroupReq.msgRetryCount = 10;
      }
      this.updateGroupReq.keywords = group.keywords;
      this.updateGroupReq.routeConId = group.routeConId;
      if (group.mockConf) {
        this.mockConfInfo = JSON.parse(group.mockConf);
        if (this.mockConfInfo.confDetails === undefined || this.mockConfInfo.confDetails === null) {
          this.mockConfInfo.confDetails = [];
        }
        if (this.mockConfInfo.isMock === undefined || this.mockConfInfo.isMock == null || !this.mockConfInfo.isMock) {
          this.mockConfInfo = lodash.cloneDeep(this.mockConfInfoInit);
        }
      } else {
        this.mockConfInfo = lodash.cloneDeep(this.mockConfInfoInit);
      }

      this.updateGroupVisible = true;
    },
    updateStrategyOfChangeSendWay() {
      this.queryTemplateReq.groupId = this.updateGroupReq.groupId;
      this.queryTemplateReq.companyId = this.company.companySelected;
      this.queryTemplateReq.type = 'ivr';
      if (this.updateGroupReq.sendWay === 'ivr') {
        this.queryTemplateReq.type = 'ivr';
      } else if (this.updateGroupReq.sendWay === 'ivoice') {
        this.queryTemplateReq.type = 'ivoice';
      } else if (this.updateGroupReq.sendWay === 'svoice') {
        this.queryTemplateReq.type = 'svoice';
      } else {
        this.queryTemplateReq.type = 'msg';
      }

      if (this.queryTemplateReq.type !== 'svoice') {
        this.$ajax({
          url: '/robotCase/getTemplateByCompanyId',
          method: 'POST',
          data: this.queryTemplateReq
        }).then((res) => {
          this.templateList = res.data;
        });
      } else {
        this.$ajax({
          url: '/scene/getSceneParam',
          method: 'POST',
          data: this.queryTemplateReq
        }).then((res) => {
          this.templateList = res.data;
        });
      }
    },
    addStrategyGroup() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.addStrategyGroupReq.mockConf = JSON.stringify(this.mockConfInfo);
      this.addStrategyGroupReq.msgRetryStatus = this.msgIsRetryLabelData.join(',');
      const uri = '/strategy/createGroup';
      this.$ajax({
        url: uri,
        data: this.addStrategyGroupReq,
        prompt: true
      }).then(() => {
        loading.close();
        this.addStrategyVisible = false;
        // 查对应的策略组
        this.groupReq.companyId = this.addStrategyGroupReq.sourceGroupId;
        this.getGroupOptionList(this.groupReq);
      }).catch(() => {
        loading.close();
      });
    },
    updateStrategyGroup() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.updateGroupReq.mockConf = JSON.stringify(this.mockConfInfo);
      if (this.msgIsRetryLabelData) {
        this.updateGroupReq.msgRetryStatus = this.msgIsRetryLabelData.join(',');
      } else {
        this.updateGroupReq.msgRetryStatus = this.initMsgIsRetryLabelData.join(',');
      }
      const uri = '/strategy/updateGroup';
      this.$ajax({
        url: uri,
        data: this.updateGroupReq,
        prompt: true
      }).then(() => {
        loading.close();
        this.updateGroupVisible = false;
        // 查对应的策略组
        this.groupReq.companyId = this.company.companySelected;
        this.getGroupOptionList(this.groupReq);
      }).catch(() => {
        loading.close();
      });
    },
    updateCollectAndTemplate() {
      const uri = '/strategy/updateCollectAndTemplate';
      this.$ajax({
        url: uri,
        data: this.updateCollectAndTemplateReq,
        prompt: true
      }).then(
        this.updateStrategyVisible = false
      );
    },
    // 批量更新模板获取策略组
    updateTemplateCompanyChange() {
      const search = {};
      search.companyIds = this.updateCompany;
      if (this.updateCompany.length === 0) {
        this.groupIdList = [];
        return;
      }
      this.$ajax({
        url: 'strategy/updateTemplateCompanyChange',
        data: search
      }).then((res) => {
        this.groupIdList = res.data;
      });
    },
    updateTemplate() {
      this.updateTemplateReq.companyIds = this.updateCompany;
      this.updateTemplateReq.groupIds = this.updateGroupId;
      const uri = '/template/getTemplate';
      let msgTypeNum = 0;
      let ivrTypeNum = 0;
      this.$ajax({
        url: uri,
        data: this.updateTemplateReq,
        prompt: true
      }).then((res) => {
        const templates = res.data;
        for (let i = 0; i < templates.length; i++) {
          if (templates[i].type === 'msg') {
            msgTypeNum += templates[i].numType;
          } else if (templates[i].type === 'ivr') {
            ivrTypeNum += templates[i].numType;
          }
        }
        this.updateTemplateMessage = `你将更新${this.updateCompany.length}家公司共${msgTypeNum}个短信模版及${ivrTypeNum}个语音模版，你确认更新吗?`;
        this.updateTemplateVisible = false;
        this.submitUpdateTemplateVisible = true;
      });
    },
    submitUpdateTemplate() {
      this.updateTemplateReq.companyIds = this.updateCompany;
      this.updateTemplateReq.groupIds = this.updateGroupId;
      const uri = '/template/batchUpdate';
      this.$ajax({
        url: uri,
        data: this.updateTemplateReq,
        prompt: true
      }).then(
        this.submitUpdateTemplateVisible = false
      );
    },
    queryAllGroupsOfThisCompany(dataReq) {
      this.$ajax({
        url: '/strategy/selectAllGroupsAndScoreInfoByCompanyId',
        method: 'POST',
        data: dataReq
      }).then((res) => {
        const strategyGroups = res.data;
        this.groupList = strategyGroups.groupList;
        this.scoreConfList = strategyGroups.scoreConfList;
      });
    },
    saveStrategyConfig() {
      this.saveScoreDeployStrategyReq.groupList = this.groupList;
      this.saveScoreDeployStrategyReq.scoreConfList = this.scoreConfList;
      this.saveScoreDeployStrategyReq.companyId = this.company.companySelected;
      this.$ajax({
        url: '/strategy/saveScoreDeployStrategy',
        data: this.saveScoreDeployStrategyReq,
        prompt: true
      }).then(
        this.strategyConfigVisible = false
      );
    },
    addStrategyConfig(item) {
      const strategyScore = {
        id: '',
        companyId: item.companyId,
        bindGroupId: item.id,
        groupId: '',
        strategyScore: [0, 100],
        type: 1,
        createUserId: '',
        updateUserId: '',
        createTime: '',
        updateTime: ''
      };
      this.scoreConfList.push(strategyScore);
    },
    deleteStrategyConfig(scoreItem, key) {
      this.scoreConfList.splice(key, 1);
      if (scoreItem.id !== null && scoreItem.id !== '') {
        this.saveScoreDeployStrategyReq.deleteList.push(scoreItem.id);
      }
    },
    delStrategyGroup(groupId) {
      this.$ajax({
        url: '/strategy/delStrategyGroup',
        params: { 'groupId': groupId },
        prompt: true
      }).then(() => {
        this.queryAllGroupsOfThisCompany(this.groupReq);
      });
    },
    synStrategy(groupId) {
      this.changeStrategyReq.selectedGroupId = groupId;
      for (let i = 0; i < this.groupList.length; i++) {
        if (this.groupList[i].isMain === 1) {
          this.changeStrategyReq.oldMainGroupId = this.groupList[i].id;
        }
      }
      this.$ajax({
        url: '/strategy/changeStrategy',
        data: this.changeStrategyReq,
        prompt: true
      }).then(() => {
        this.queryAllGroupsOfThisCompany(this.groupReq);
      });
    },
    generator(name, index) {
      return `${name}${index}`;
    },
    addTemplate() {
      this.addOrEditTemplate(true, this.templateOperType.add, this.company.companySelected, this.group.groupSelected, null);
    },
    addOrEditTemplate(templateVisible, templateOper, companyId, groupId, row) {
      this.$refs.addTemplate.addOrEditTemplate(templateVisible, templateOper, companyId, groupId, row);
    },
    deleteTemplate(id) {
      this.$refs.addTemplate.deleteTemplate(id);
    },
    openAndCloseTemplate(row) {
      this.$refs.addTemplate.openAndCloseTemplate(row);
    },
    getCaseStatusParam() {
      this.$ajax({
        url: '/dict/getCaseStatusParam',
        method: 'GET'
      }).then((res) => {
        this.caseStatusOption = res.data;
      });
    },
    getContactStatusParam() {
      this.$ajax({
        url: '/dict/getContactStatusParam',
        data: { contactStatusType: this.contactStatusType.benrendianhua },
        method: 'POST'
      }).then((res) => {
        this.contactStatusOption = res.data;
      });
    },
    getMsgRetryStatusTypes() {
      this.$ajax({
        url: '/dict/list/msgRetryStatusType',
        method: 'GET'
      }).then((res) => {
        this.msgRetryStatusTypes = res.data;
        this.initMsgIsRetryLabelData = [];
        if (res.data) {
          res.data.forEach((item) => {
            this.initMsgIsRetryLabelData.push(item.modelCode);
          });
        }
        this.msgIsRetryLabelData = this.initMsgIsRetryLabelData;
      });
    },
    getLabelParams() {
      const req = {
        'companyId': this.company.companySelected
      };
      this.$ajax({
        url: '/label/getLabelParams',
        method: 'POST',
        data: req
      }).then((res) => {
        this.labelOption = res.data;
      });
    },
    search() {
      // 更新一下模板列表
      this.msgTemplateListClick();
      this.voiceTemplateListClick();
      this.sceneTemplateListClick();
    },
    initTemplateList() {
      const reqMsg = {};
      reqMsg.groupId = this.group.groupSelected;
      reqMsg.type = this.templateType.tempTypeMsg;
      this.$ajax({
        url: '/template/getTemplatesParam',
        method: 'POST',
        data: reqMsg
      }).then((res) => {
        this.templateMsgOption = res.data;
      });
      const reqVoice = {};
      reqVoice.groupId = this.group.groupSelected;
      reqVoice.type = this.templateType.tempTypeVoice;
      this.$ajax({
        url: '/template/getTemplatesParam',
        method: 'POST',
        data: reqVoice
      }).then((res) => {
        this.templateVoiceOption = res.data;
      });
      const reqIVoice = {};
      reqIVoice.groupId = this.group.groupSelected;
      reqIVoice.type = this.templateType.tempTypeIVoice;
      this.$ajax({
        url: '/template/getTemplatesParam',
        method: 'POST',
        data: reqIVoice
      }).then((res) => {
        this.templateIVoiceOption = res.data;
      });
      const reqSVoice = {};
      reqSVoice.groupId = this.group.groupSelected;
      reqSVoice.type = this.templateType.tempTypeIVoice;
      this.$ajax({
        url: '/scene/getSceneParam',
        method: 'POST',
        data: reqSVoice
      }).then((res) => {
        this.templateSVoiceOption = res.data;
      });
    },
    initTemplateFiled(templateOperType) {
      console.warn(`${this.company.companySelected}pp`);
      this.$refs.addTemplate.initTemplateFiled(templateOperType, this.company.companySelected);
    },
    groupConfig() {
      this.$refs.groupConfig.addOrEditGroupConfig();
    },
    addRow() {
      const newRow = {
        number: this.mockConfInfo.confDetails.length + 1,
        weight: ''
      };
      this.mockConfInfo.confDetails.push(newRow);
    },
    deleteRow(number) {
      this.mockConfInfo.confDetails.splice(number, 1);
      // 更新序号
      this.mockConfInfo.confDetails.forEach((row, i) => {
        row.number = i + 1;
      });
    }
  },
  components: {
    sendRule,
    contactStatus,
    caseStatus,
    voiceTemplateList,
    msgTemplateList,
    labelList,
    addTemplate,
    strategyOverview,
    ivoiceTemplateList,
    panel,
    voiceScene,
    sceneTemplate,
    templateFiled,
    groupConfig
  }
};
</script>
<style lang="less" scoped>
.sc-row {
  margin-bottom: 15px;
  .sc-row__title {
    padding: 5px 0 0 0;
    text-align: right;
    strong {
      font-weight: 600;
    }
  }
  .sc-row__content {
    .send-percent {
      margin-bottom: 5px;
      .percent {
        width: 120px;
        margin: 0 10px;
      }
    }
    .score-table {
      margin: 15px 0;
      table {
        th, td {
          text-align: center;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/main/collection/engine/index.vue